// import { apiEleg } from '../../config/api'
import { getIFIModule, getIFIPDF } from '../../config/apiSinToken'

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra las mipymes que le pertenecen a la ifi por Id
 * Fecha: 15-8-2022
 */
export const getMIPYMESList = async (params) => {
  const data = await getIFIModule(
    `api/v1/MiPymes/GetMipymesByUser?IdUserAzureB2C=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion que obtendra las mipymes validadas
 * Fecha: 6-15-2023
 */
export const getMIPYMESListValidate = async (params) => {
  const data = await getIFIModule(
    `api/v1/MiPymes/preElegibleStateByUser/${params}`,
  )
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Descripcion: Funcion que obtendra listado de tipos de mipymes
 * Fecha: 15-8-2022
 */
export const getMIPYMESTypeList = async () => {
  const data = await getIFIModule(`api/v1/MiPymeTypes/List
  `)
  return data
}

export const getIFI = async (params) => {
  const data = await getIFIModule(`api/v1/IFIS/findIFI/${params}`)
  return data
}

export const getFormulariosDraftIFIS = async (params) => {
  const data = await getIFIModule(
    `api/v1/Forms/getDraftFormsByIfi/${params}/${true}`,
  )
  return data
}

export const getFormulariosSentIFIS = async (params) => {
  const data = await getIFIModule(
    `api/v1/Forms/getDraftFormsByIfi/${params}/${false}`,
  )
  return data
}
export const getFormularioPrelegibilidad = async (params) => {
  if (params !== []) {
    const data = await getIFIModule(
      `api/v1/FormPreElegibility/getFormPreElegibilityById/${params}`,
    )
    return data
  }
}

export const getPreIFIPDF = async (idForm, fecha) => {
  const data = await getIFIPDF(`PreElegibility/DownloadPdf/${idForm}/${fecha}`)
  return data
}

/**
Chang
 * Author: wraudales@ngshn.com
 * Descripcion: Endpoint que brinda IFIS by IdCountry
 * Fecha: 28-9-2022
 */
export const getIFISbyCountry = async (idCountry) => {
  const data = await getIFIModule(`api/v1/IFIS/IFIsListByCountry/${idCountry}
  `)
  return data
}
/**
 * Author: wraudales@ngshn.com
 * Descripcion: Endpoint que brindar pais por ID
 * Fecha: 28-9-2022
 */
export const getCountryByID = async (idCountry) => {
  const data = await getIFIModule(`api/v1/Countries/GetById/${idCountry}
  `)
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener la informacion de lo usuarios que pertenecen a una ifi
 * Fecha: 14-8-2023
 */
export const getGetUserIfis = async (param) => {
  const data = await getIFIModule(`api/v1/Users/GetUser/MiPymes-Ifi?IFI=${param}
  `)
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener la informacion de lo usuarios que pertenecen a una ifi
 * Fecha: 14-8-2023
 */
export const getMIPYMERepresentation = async (param) => {
  const data = await getIFIModule(
    `api/v1/IFIS/MiPymesRepresentedByIFIS/${param}`,
  )
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener la solicitudes pendientes
 * Fecha: 4-4-2024
 */
export const getMIPYMENotificationRepresentation = async (param) => {
  const data = await getIFIModule(
    `api/v1/Notifications/NotificationRepresentationActive?UserB2c=${param}`,
  )
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener las mipymes bloquedas por ifi
 * Fecha: 7-5-2024
 */
export const getMIPYMEBlockingIFI = async (param) => {
  const data = await getIFIModule(
    `api/v1/MiPymes/AllMiPymes/Ifi-Blocking/${param}`,
  )
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener las mipymes por IFI
 * Fecha: 18-7-2024
 */
export const getMIPYMEByIFI = async (param) => {
  const data = await getIFIModule(
    `api/v1/MiPymes/GetMiPymesByIfi/${param}/false`,
  )
  return data
}

/**
 * Author: degrandezg@ngshn.com
 * Descripcion: Endpoint que obtener los usuarios de las mipymes
 * Fecha: 18-7-2024
 */
export const getUserbyMIPYME = async (idMipyme, idIfi) => {
  const data = await getIFIModule(
    `api/v1/Users/getUsersForReassignment/${idMipyme}/idIFI?idIFI=${idIfi}`,
  )
  return data
}
